var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDdx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11h4.53a4.78 4.78 0 0 1 4.78 4.78H1V11zm10.317 0h4.529a4.78 4.78 0 0 1 4.78 4.78h-9.31V11zM5.529 21.568H1v-4.78h9.31a4.78 4.78 0 0 1-4.78 4.78zm5.787 0h4.529a4.78 4.78 0 0 0 4.78-4.78h-9.31v4.78zM23.602 11h-3.346l7.404 10.568H31L23.602 11zm1.24 0 3.082 4.397L31 11H24.84zm-1.498 6.165 3.083 4.403h-6.159l3.076-4.403z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDdx);
export default __webpack_public_path__ + "static/media/DDX.84cfc81cf86e698aaeb11a6092636dbe.svg";
export { ForwardRef as ReactComponent };